// extracted by mini-css-extract-plugin
module.exports = {"root":"PageBackdrop_root__cqfib","wrapper":"PageBackdrop_wrapper__y7JaD","show":"PageBackdrop_show__naPdV","active":"PageBackdrop_active__bKR4T"};